export default class SimpleAccordion {
    constructor(el) {
        this.el = el;
        this.isOpen = false;
        this.openButtonSelector = el.dataset.openButton;
        this.mainElSelector = el.dataset.mainEl;

        this.openButton = this.el.querySelector('.' + this.openButtonSelector);
        this.mainEl = this.el.querySelector('.' + this.mainElSelector);

        this.openButton.addEventListener('click', () => {
            this.toggleAccordion();
        });
    }

    openAccordion() {
        this.isOpen = true;
        this.el.classList.add('simple-accordion--open');
    }

    closeAccordion() {
        this.isOpen = false;
        this.el.classList.remove('simple-accordion--open');
    }

    toggleAccordion() {
        if(this.isOpen) {
            this.closeAccordion();
        } else {
            this.openAccordion();
        }
    }
};